const store = {
    namespaced: true,
    state() {
        return {
            isAuth: false,
            insertedEmail: '',
            userData: null,
            specificUserData: null,
            loginStatusCode: null,
            profileToken: null,
            isShowLoginNotification: false,
        };
    },
    getters: {
        isAuth: state => state.isAuth,
        getIsAuth: state => state.isAuth,
        insertedEmail: state => state.insertedEmail,
        userData: state => state.userData,
        specificUserData: state => state.specificUserData,
        loginStatusCode: state => state.loginStatusCode,
        profileToken: state => state.profileToken,
        getLoginNotification: state => state.isShowLoginNotification,
    },
    mutations: {
        SET_INSERTED_EMAIL: (state, str) => (state.insertedEmail = str),
        SET_IS_AUTH: (state, flag) => (state.isAuth = flag),
        SET_USER_DATA: (state, data) => (state.userData = data),
        SET_SPECIFIC_USER_DATA: (state, data) => (state.specificUserData = data),
        SET_LOGIN_STATUS_CODE: (state, code) => (state.loginStatusCode = code),
        SET_PROFILE_TOKEN: (state, token) => (state.profileToken = token),
        SET_LOGIN_NOTIFICATION: (state, flag) => (state.isShowLoginNotification = flag),
    },
    actions: {
        setInsertedEmail: ({ commit }, str) => commit('SET_INSERTED_EMAIL', str),
        setLoginStatusCode: ({ commit }, code) => commit('SET_LOGIN_STATUS_CODE', code),

        socialAuthentification: async function ({ commit, dispatch }, { access, strategy }) {
            // try {
            const { data } = await this.$axios({
                method: 'POST',
                url: `/users/google-auth/`,
                data: {
                    access_token: access,
                    platform: strategy,
                },
            });

            console.log(data);

            await this.dispatch('user/setAuthData', {
                access: data.access_token,
                refresh: data.refresh_token,
            });
        },

        setAuthData: async function ({ commit }, data) {
            const expiresDate = new Date();
            expiresDate.setDate(expiresDate.getDate() + 2); // 2 дня

            this.$cookies.set('AuthToken', data.access, {
                path: '/',
                maxAge: 2 * 24 * 60 * 60,
                expires: expiresDate,
                sameSite: 'None',
                secure: true,
            });

            if (data.refresh) {
                this.$cookies.set('RefreshToken', data.refresh, {
                    path: '/',
                    maxAge: 7 * 24 * 60 * 60,
                    expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
                    sameSite: 'None',
                    secure: true,
                });
            }

            this.$axios.setHeader('Authorization', `Bearer ${data.access}`);
            commit('SET_PROFILE_TOKEN', data.access);
            commit('SET_IS_AUTH', true);

            await this.dispatch('user/fetchUserData');
        },

        login: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'post',
                    url: `/auth/jwt/create/`,
                    data: {
                        email: data.email,
                        password: data.password,
                    },
                });

                await this.dispatch('user/setAuthData', {
                    access: res.data.access,
                    refresh: res.data.refresh,
                });
                const expiresDate = new Date();
                expiresDate.setDate(expiresDate.getDate() + 2);

                this.$cookies.set('AuthToken', res.data.access, {
                    path: '/',
                    expires: expiresDate,
                    sameSite: 'None',
                    secure: true,
                });
                this.$axios.setHeader('Authorization', `Bearer ${res.data.access}`);
                commit('SET_IS_AUTH', true);
                commit('SET_PROFILE_TOKEN', res.data.access);

                await this.dispatch('user/fetchUserData');
                commit('SET_LOGIN_NOTIFICATION', true);

                setTimeout(() => {
                    this.$router.push({ path: this.localePath('/') });
                }, 1000);

                setTimeout(() => {
                    commit('SET_LOGIN_NOTIFICATION', false);
                }, 3000);
            } catch (error) {
                commit('SET_LOGIN_STATUS_CODE', error.response.status);
                return error.response;
            }
        },

        logout: async function ({ commit }) {
            try {
                this.$cookies.remove('AuthToken');
                this.$cookies.remove('RefreshToken');
                this.$axios.setHeader('Authorization', null);
                commit('SET_IS_AUTH', false);
                commit('SET_USER_DATA', null);
                commit('SET_PROFILE_TOKEN', null);
            } catch (error) {
                console.dir(error);
            }
        },
        register: async function ({ commit }, data) {
            const res = await this.$axios({
                method: 'post',
                url: `/api/register/`,
                data: {
                    phone: data.phone.replace(/\s/g, ''),
                },
            });
        },
        resetPassword: async function ({ commit }, data) {
            const res = await this.$axios({
                method: 'patch',
                url: `/api/register/${data.phone.replace(/\s/g, '')}/`,
            });
        },
        loginGoogle: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'post',
                    url: `/api/google-login/`,
                    data: { access_token: data.access_token },
                });
                const { access, refresh } = res.data;
                await this.dispatch('user/setAuthData', {
                    access,
                    refresh,
                });
                this.$router.push({ path: this.localePath('/') });
            } catch (error) {
                this.$router.push({ path: this.localePath('/registration') });
            }
        },
        fetchUserData: async function ({ commit, getters }) {
            const token = getters.profileToken || this.$cookies.get('AuthToken');

            try {
                const user = await this.$axios({
                    method: 'GET',
                    url: `/users/user-group/`,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const userGroupId = user?.data?.[0]?.group_user_type?.id;
                const userGroupIdInCookie = this.$cookies.get('user-group-id') || null;

                if (!userGroupIdInCookie && userGroupId) {
                    await this.$cookies.set('user-group-id', userGroupId);
                }

                const company = user?.data[0]?.company;

                // Форматируем данные пользователя
                user.data[0] = {
                    ...user.data[0],
                    loyalty_points: Number(user?.data[0]?.loyalty_points) || 0,
                };

                commit('SET_USER_DATA', user.data[0]);
                commit('SET_SPECIFIC_USER_DATA', company);
            } catch (error) {
                console.error(error);
                if (error?.response?.status === 401) {
                    this.$cookies.remove('token');
                    this.$cookies.remove('refreshToken');
                    this.$cookies.remove('user-group-id');
                    this.$axios.setHeader('Authorization', null);

                    commit('SET_IS_AUTH', false);
                    commit('SET_USER_DATA', null);
                    commit('SET_PROFILE_TOKEN', null);

                    // Очищаем локальное хранилище
                    if (process.client) {
                        localStorage.removeItem('favorites');
                    }

                    await this.$router.push({ path: this.localePath('/') });
                }
            }
        },
        fetchUserDataById: async function ({ commit }, userId) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/api/users/${userId}/`,
                });
                commit('SET_SPECIFIC_USER_DATA', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
    },
};

export default store;
